var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 163,
    viewBox: "0 0 226 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    y: 29.5859,
    width: 123.044,
    height: 123.044,
    rx: 7.43653,
    transform: "rotate(-11.526 0 29.5859)",
    fill: "#CADEF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 112.781,
    y: 0.421875,
    width: 123.044,
    height: 123.044,
    rx: 7.43653,
    transform: "rotate(23.824 112.781 0.421875)",
    fill: "#CADEF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1719 39.5L100.226 63.3282C115.73 72.1128 122.28 72.1128 137.784 63.3282L179.839 39.5",
    stroke: "#141B34",
    strokeWidth: 9.125,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2678 84.9779C58.6655 103.627 58.8643 112.951 65.7454 119.858C72.6264 126.766 82.2031 127.006 101.356 127.487C113.161 127.784 124.849 127.784 136.654 127.487C155.808 127.006 165.384 126.766 172.265 119.858C179.146 112.951 179.345 103.627 179.742 84.9779C179.871 78.9815 179.871 73.0211 179.742 67.0247C179.345 48.376 179.146 39.0517 172.265 32.1445C165.384 25.2373 155.808 24.9967 136.654 24.5154C124.849 24.2188 113.161 24.2188 101.356 24.5154C82.2031 24.9966 72.6264 25.2372 65.7453 32.1444C58.8643 39.0516 58.6655 48.376 58.2677 67.0247C58.1399 73.0211 58.1399 78.9815 58.2678 84.9779Z",
    stroke: "#141B34",
    strokeWidth: 9.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerify);
export default __webpack_public_path__ + "static/media/email_verify.cc583c8cae7a8c891b6ecb8702eed050.svg";
export { ForwardRef as ReactComponent };